const pageFadeDurationMs = 200;
const cardExitDurationMs = 250;
const header = "_275h3jgm9t";
const heading = "_275hmrqrfj";
const headingHeart = "_275hcnuodt";
const content = "_275c7tyzwx";
const message = "_275mcfmrr0";
const listWrapper = "_275l1laxk7u";
const listHeading = "_275l1vph6tg";
const list = "_275lyzhulm";
const listItem = "_275l1i1mu9b";
const emptyListMessage = "_275e2mzvex";

export { cardExitDurationMs, content, emptyListMessage, header, heading, headingHeart, list, listHeading, listItem, listWrapper, message, pageFadeDurationMs };
import "./_favourites-page.style.linaria.module.css";
//# sourceMappingURL=_favourites-page.style.js.map
